import axios from 'axios'; 
import i18n from './i18n';

export let https=axios.create({
    headers:{
        AccessControlAllowOrigin: '*',
        lang:i18n.language
    }
})